import { AgentCategoryEnum } from "../../enums/AgentCategory.enum";
import { IAgent } from "../../models/Agent.model";

export const FakeAgents: IAgent[] = [
//   {
//     id: "1",
//     name: "Test Case Analyser Agent",
//     description:
//       "A comprehensive agent that extracts, parses, writes, and generates summaries for test cases from Excel files.",
//     agentFormData: {
//       agentName: "Test Case Analyser Agent",
//       agentDescription:
//         "This agent handles the complete workflow for analyzing test cases, including extracting content from Excel, parsing the text, writing outputs to TXT and README files, and generating a summary.",
//       prompt: `You are an AI assistant acting as a Senior Test Engineer with extensive experience in the banking domain and comprehensive knowledge of ISO20022, SWIFT MT, Payment Schemes, and the messages involved.
// Your task is to analyze a given test scenario, summarize it, extract key information, provide suggestions for improvement, and create a sequence diagram to visualize the flow.

// Here is the test scenario you need to analyze:

// <test_scenario>
// {test_scenario}
// </test_scenario>

// Follow these steps to complete your analysis:

// 0. Below are some of the systems involved in the test scenario:
//     a. CC : Control Center
//     b. MTS : Money Transfer System
//     c. Adaptors
//     c. Simulators : FED, CHIPS, SAA
//     d. Video 
//     e. Database

// 1. Summarize the test scenario in this format:

// Scenario Summary:

// Scenario: [Scenario Name]
// Sending: [Brief description of what is being sent]
// Receiving: [Brief description of what is being received]
// Outcome: [Expected outcome of the scenario]
// Flow: [Straight Through Processing (STP) or Repair Flow].
// Description: [Detailed description of the scenario]


// 2. Extract and present the following information in a clear, organized manner:

//   a. Systems Involved
//   b. Payment Schemes Involved
//   c. Message Types Involved
//   d. Inbound or Outbound Message or Both
//   e. Use TestName and Description field from Test Scenario to identify STP( Straight Through Processing) or Repair. 
//       If Repair is not mentioned in TestName or Description, consider it as Straight Through Processing (STP). 
//   f. A detailed summary of what the test case aims to achieve
//   g. Any other information that makes it easier to understand the test case

// 3. Provide suggestions on how this test case can be improved. Consider aspects such as:
//   - Coverage of edge cases
//   - Clarity of expected outcomes   

// 4. Create a sequence diagram using Mermaid syntax to visualize the flow of the test scenario. Include all relevant systems, messages, and actions. The diagram should be enclosed in mermaid tags.

// 5. Before providing your final answer, use a <scratchpad> to organize your thoughts and analyze the scenario. In your scratchpad, break down the scenario, identify key components, and make notes about each required piece of information.

// 6. Present your findings in a clear, structured format using markdown. Use appropriate headers, lists, and formatting to make the information easily readable and understandable.

// Your final output should be enclosed in <answer> tags and formatted in markdown. It should include all the extracted information, the detailed summary, additional insights, and the sequence diagram.

// Maintain a professional tone and leverage your expertise in the banking domain to provide valuable insights and suggestions.

// Begin your analysis now.`,
//       tools: [
//         "Excel Tool",
//         "Parsing Tool",
//         "File Writing Tool - Test Case",
//         "File Writing Tool - Test Case Analysis",
//       ],
//       model: {
//         label: "gpt-4o",
//         field: "gpt-4o",
//       },
//       flow: {
//         nodes: [
//           {
//             id: "0",
//             type: "AgentNode",
//             position: {
//               x: 350,
//               y: 150,
//             },
//             data: {
//               id: "0",
//               title: "Extract Text from Excel",
//               formData: {
//                 functions: ["extract_text_from_excel"],
//                 input: [
//                   {
//                     key: "excel_path",
//                     type: TypeEnum.Input,
//                     description: "Path to the Excel file.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Input,
//                   description: "Extracted sheet data",
//                 },
//               },
//             },
//             className: "",
//           },
//           {
//             id: "1",
//             type: "AgentNode",
//             position: {
//               x: 700,
//               y: 150,
//             },
//             data: {
//               id: "1",
//               title: "Parse Excel Text",
//               formData: {
//                 functions: ["parse_excel_text"],
//                 input: [
//                   {
//                     key: "sheet_data",
//                     type: TypeEnum.Input,
//                     description: "Extracted data from the Excel file.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Input,
//                   description: "Structured test cases",
//                 },
//               },
//             },
//             className: "",
//           },
//           {
//             id: "2",
//             type: "AgentNode",
//             position: {
//               x: 1050,
//               y: 150,
//             },
//             data: {
//               id: "2",
//               title: "Write Test Cases to TXT",
//               formData: {
//                 functions: ["write_test_cases_to_txt"],
//                 input: [
//                   {
//                     key: "structured_test_cases",
//                     type: TypeEnum.Input,
//                     description: "Parsed test cases to write",
//                   },
//                   {
//                     key: "txt_output_path",
//                     type: TypeEnum.Input,
//                     description: "Output path for TXT file.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Switch,
//                   description: "Confirmation of file creation",
//                 },
//               },
//             },
//             className: "",
//           },
//           {
//             id: "3",
//             type: "AgentNode",
//             position: {
//               x: 1400,
//               y: 150,
//             },
//             data: {
//               id: "3",
//               title: "Generate README Summary",
//               formData: {
//                 functions: ["generate_test_case_analysis_llm"],
//                 input: [
//                   {
//                     key: "structured_test_cases",
//                     type: TypeEnum.Input,
//                     description: "Parsed test cases for summary",
//                   },
//                   {
//                     key: "readme_output_path",
//                     type: TypeEnum.Input,
//                     description: "Output path for README file.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Switch,
//                   description: "Result of README generation",
//                 },
//               },
//             },
//             className: "",
//           },
//         ],
//         edges: [
//           {
//             id: "e0-1",
//             source: "0",
//             target: "1",
//             type: "smoothstep",
//           },
//           {
//             id: "e1-2",
//             source: "1",
//             target: "2",
//             type: "smoothstep",
//           },
//           {
//             id: "e2-3",
//             source: "2",
//             target: "3",
//             type: "smoothstep",
//           },
//         ],
//       },
//       welcomeText:
//         "Welcome to the Test Case Analyser Agent. This agent will guide you through extracting, parsing, writing, and summarizing test cases from Excel files.",
//     },
//     category: AgentCategoryEnum.Analyser,
//     logo: "/assets/images/randon-logo.png",
//   },
//   {
//     id: "2",
//     name: "Test Data Preparation Agent",
//     description:
//       "An agent for preparing test data files, including generating Excel sheets for test cases and creating load files from summaries.",
//     agentFormData: {
//       agentName: "Test Data Preparation Agent",
//       agentDescription:
//         "This agent handles test data preparation by generating structured Excel sheets and load files, enabling smooth integration with downstream testing processes.",
//       prompt: `You are an expert in the Banking Domain tasked with generating an XML template for high-value payments using the FED scheme. Your goal is to create an XML file that includes both mandatory and optional fields based on the given scenario.

// You will be provided with the following inputs:
// <message_type>{message_type}</message_type>
// <version>{version}</version>
// <scenario>{scenario}</scenario>
// <scheme>{scheme}</scheme>

// Follow these steps to generate the XML template:

// 1. Analyze the provided message type, version, scenario, and scheme to determine the appropriate XML structure.

// 2. Use the following base XML structure as a starting point based on the value of the scheme:

// If the scheme is "FedwireFundsOutgoing":
// <?xml version="1.0" encoding="UTF-8"?>
// <FedwireFundsOutgoing xmlns="urn:fedwirefunds:outgoing:v001">
//     <FedwireFundsOutgoingMessage>
//         <FedwireFundsCustomerCreditTransfer>
//             <AppHdr xmlns="urn:iso:std:iso:20022:tech:xsd:head.001.001.03">
//                 <!-- AppHdr content -->
//             </AppHdr>
//             <Document xmlns="urn:iso:std:iso:20022:tech:xsd:{message_type}.{version}">
//                 <!-- Document content based on message type -->
//             </Document>
//         </FedwireFundsCustomerCreditTransfer>
//     </FedwireFundsOutgoingMessage>
// </FedwireFundsOutgoing>

// If the scheme is "FedwireFundsIncoming":
// <?xml version="1.0" encoding="UTF-8"?>
// <FedwireFundsIncoming xmlns="urn:fedwirefunds:incoming:v001">
//     <FedwireFundsIncomingMessage>
//         <FedwireFundsCustomerCreditTransfer>
//             <AppHdr xmlns="urn:iso:std:iso:20022:tech:xsd:head.001.001.03">
//                 <!-- AppHdr content -->
//             </AppHdr>
//             <Document xmlns="urn:iso:std:iso:20022:tech:xsd:{message_type}.{version}">
//                 <!-- Document content based on message type -->
//             </Document>
//         </FedwireFundsCustomerCreditTransfer>
//     </FedwireFundsIncomingMessage>
// </FedwireFundsIncoming>

// 3. Fill in the AppHdr section with appropriate placeholder values, including sender and receiver information, message identification, and creation date.

// 4. Based on the message type and version, create the appropriate structure within the Document tags. For example, if the message type is pacs.008, use <FIToFICstmrCdtTrf> as the root element within Document.

// 5. Include all mandatory fields for the given message type and scenario. Refer to the ISO 20022 standards and FED guidelines to ensure compliance.

// 6. Add relevant optional fields based on the provided scenario. Consider the following aspects:
//    - Transaction Type (Customer vs. Interbank Transfers)
//    - Cross-Border requirements
//    - Priority or Urgency indicators
//    - Bulk payment structures (if applicable)
//    - Currency conversion information
//    - Regulatory requirements (AML/CFT compliance)
//    - Extended remittance information

// 7. Use placeholder values for fields that require specific data, such as:
//    - Unique identifiers (e.g., UETR, InstrId, EndToEndId)
//    - Financial institution identifiers (e.g., BIC, Clearing System Member ID)
//    - Amount and currency
//    - Dates and timestamps

// 8. Ensure that all XML elements are properly nested and follow the correct hierarchy according to the ISO 20022 standards.

// 9. Include appropriate namespace declarations for all elements.

// 10. If the scenario involves multiple transactions (e.g., bulk payments), create the necessary structure to accommodate multiple CdtTrfTxInf elements.

// 11. For scenarios involving special requirements (e.g., regulatory compliance), add the relevant elements and attributes to capture the necessary information.

// 12. If any aspect of the scenario is unclear or cannot be represented in the standard XML structure, include a comment in the XML explaining the limitation or assumption made.

// 13. Validate the generated XML structure to ensure it complies with the ISO 20022 schema for the given message type and version.

// Output the complete XML file, ensuring it is well-formed and properly indented for readability. Do not include any explanations or text outside of the XML structure itself. Your entire response should be valid XML.    
//       `,
//       tools: [
//         "File Writing Tool - Excel Sheet Generator",
//         "Load File Generator Tool",
//       ],
//       model: {
//         label: "gpt-4o",
//         field: "gpt-4o",
//       },
//       flow: {
//         nodes: [
//           {
//             id: "0",
//             type: "AgentNode",
//             position: {
//               x: 350,
//               y: 150,
//             },
//             data: {
//               id: "0",
//               title: "Generate Excel Sheet for Test Cases",
//               formData: {
//                 functions: ["generate_excel_sheet_for_test_cases"],
//                 input: [
//                   {
//                     key: "test_cases_path",
//                     type: TypeEnum.Input,
//                     description:
//                       "Path to the original Excel file with test cases.",
//                   },
//                   {
//                     key: "excel_input_path",
//                     type: TypeEnum.Input,
//                     description: "Path to an additional input Excel file.",
//                   },
//                   {
//                     key: "excel_output_path",
//                     type: TypeEnum.Input,
//                     description: "Directory for the output Excel file.",
//                   },
//                   {
//                     key: "test_cases_sheet_name",
//                     type: TypeEnum.Input,
//                     description: "Sheet name for the test cases.",
//                   },
//                   {
//                     key: "test_scenarios_json_path",
//                     type: TypeEnum.Input,
//                     description: "Path to JSON file with test scenarios.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Input,
//                   description: "Path to the generated Excel file",
//                 },
//               },
//             },
//             className: "",
//           },
//           {
//             id: "1",
//             type: "AgentNode",
//             position: {
//               x: 700,
//               y: 150,
//             },
//             data: {
//               id: "1",
//               title: "Generate Load File",
//               formData: {
//                 functions: ["generate_load_files_from_readme"],
//                 input: [
//                   {
//                     key: "readme_output_path",
//                     type: TypeEnum.Input,
//                     description: "Path to the README summary file.",
//                   },
//                   {
//                     key: "load_file_output_directory",
//                     type: TypeEnum.Input,
//                     description: "Directory for saving generated load files.",
//                   },
//                   {
//                     key: "generate_load_file_flag",
//                     type: TypeEnum.Input,
//                     description:
//                       "Flag indicating whether to generate load files.",
//                   },
//                 ],
//                 output: {
//                   type: "array",
//                   description:
//                     "Paths to the generated load files or confirmation message",
//                 },
//               },
//             },
//             className: "",
//           },
//         ],
//         edges: [
//           {
//             id: "e0-1",
//             source: "0",
//             target: "1",
//             type: "smoothstep",
//           },
//         ],
//       },
//       welcomeText:
//         "Welcome to the Test Data Preparation Agent. This agent generates Excel sheets and load files, supporting test case preparation and data organization.",
//     },
//     category: AgentCategoryEnum.Generation,
//     logo: "/assets/images/randon-logo.png",
//   },
//   {
//     id: "3",
//     name: "BDD Test Generation Agent",
//     description:
//       "An agent for generating BDD (Behavior-Driven Development) test files using structured test cases and predefined patterns.",
//     agentFormData: {
//       agentName: "BDD Test Generation Agent",
//       agentDescription:
//         "This agent generates feature files in BDD format from structured test cases, utilizing patterns for consistent and standardized test scenarios.",
//       prompt: `You are a senior automation tester tasked with writing a feature file based on workflows derived from test cases. Instead of focusing on individual test case steps, your goal is to create a well-structured, consistent feature file by mapping predefined workflow steps to the common patterns file. Follow these steps:

// Review the Pattern File Content: <pattern_file>
// {pattern_file}
// </pattern_file>

// Analyze the Test Case Name: <test_case>
// {test_case}
// </test_case>

// From the test case name, identify the following:

// Inbound Simulator: Determine the inbound simulator (e.g., "SWF,SAA,CHIPS,FED") based on the test case name.
// Outbound Simulator: Identify the outbound simulator (e.g., "FED"). based on test case.

// Apply this simulators while generating the feature file 


// Analyze the Process Type: <process_type>
// {flow}
// </process_type>



// (compulsory step) make sure only Based on the process_type determine the workflow to be used ignore the testcase name while selecting the flow , 

// Select the Appropriate Workflow: Based on the identified simulators and process type, select one of the following predefined workflows which is similar  to {flow}:


// <Straight-through Process Workflow:>


// i) Global variables setup
// ii) Test Data Map Creation
// iii) Simulator Queue and Configuration Updates
// iv) Establish SSH connections
// v) Running inbound simulators
// vi) Running outbound simulators(compulsory step)
// vii) Control Center Application Interaction and Validation for Control Center(Payments page)
// viii)Party validation in control centre(compulsory step)
// ix) Control Center Message Log Validation
// x) Generating and Validating Message Prints


// <Repair Process Workflow - repair in control centre:>
// i) Global variables setup
// ii) Test Data Map Creation
// iii) Simulator Queue and Configuration Updates
// iv) Establish SSH connections
// v) Running inbound simulators
// vi) Launching and Validation of Data in Control Center Repair Screen(Exceptions Page)
// vii) Update credit dates or credit party and submit the transaction
// viii)Log in as a different user and verify
// ix) Run outbound simulators
// x) Application Interaction and Validation in Control Center (INQ Screen)
// xi)Control Center Message Log Validation
// xii)Generating and Validating Message Prints


// <Repair Process Workflow - repair in MTS Video screen :>
// below are steps for repair in video:-

// i) Global variables setup
// ii) Test Data Map Creation
// iii) Simulator Queue and Configuration Updates
// iv) Establish SSH connections
// v) Running inbound simulators
// vi) MTS Video Application Initialization and TRN Extraction
// vii)Test Data Update and Transaction Opening in MTS Video
// viii) Field Validation and Message Verification in 'RPR' Screen in MTS Video
// ix)Transaction Release and Application Logout from MTS Video
// x)Secondary User Validation and Outbound Process in MTS Video
// xi) Run outbound simulators
// xii) Application Interaction and Validation in Control Center (INQ Screen)
// xiii) Control Center Message Log Validation (compulsory step)
// xiv) Generating and Validating Message Prints



// Make sure while generating feature file you dont omit any workflow steps.

// Map Workflow Steps to Common Patterns: For the selected workflow, map each step directly to the corresponding common pattern in the pattern file. Use the "Usage" section of the pattern file for guidance on applying the correct "Given," "When," and "Then" steps.
// make sure for each workflow step you must have a pattern associated with it.you must not skip any of the workflow step.


// Do not map the workflow steps to test case steps.


// If a specific workflow step does not have an exact match in the pattern file, use the closest applicable pattern, while preserving the overall structure of the workflow.
// Structure Your Feature File: Structure your feature file based on the mapped workflow steps. For each mapped workflow step, use the corresponding "Given," "When," and "Then" statements from the common patterns file to ensure consistency.

// Maintain Consistency: Ensure uniformity in formatting and structure throughout the feature file. Use clear, descriptive language that is easy to understand for both technical and non-technical stakeholders.

// Handle Non-Matching Patterns: If any workflow step does not have an appropriate match in the pattern file, adapt the closest matching pattern while maintaining the overall workflow structure.

// Generate the Feature File: Write your complete feature file within <feature_file> tags, ensuring proper indentation and formatting for readability.

// <feature_file>

// [Your generated feature file goes here]

// </feature_file>

// Explain Your Process: After completing the feature file, briefly explain your thought process and any challenges encountered in mapping the workflow to the patterns inside <explanation> tags.

// <explanation>

// [Your explanation goes here]

// </explanation>      
//       `,
//       tools: ["Feature Generation Tool"],
//       model: {
//         label: "gpt-4o",
//         field: "gpt-4o",
//       },
//       flow: {
//         nodes: [
//           {
//             id: "0",
//             type: "AgentNode",
//             position: {
//               x: 350,
//               y: 150,
//             },
//             data: {
//               id: "0",
//               title: "Generate Feature File",
//               formData: {
//                 functions: ["evaluate_feature_file_quality"],
//                 input: [
//                   {
//                     key: "structured_test_cases",
//                     type: TypeEnum.Input,
//                     description:
//                       "Structured test cases to be used for feature file generation.",
//                   },
//                   {
//                     key: "pattern",
//                     type: TypeEnum.Input,
//                     description:
//                       "Path to the pattern file for BDD feature file creation.",
//                   },
//                   {
//                     key: "json_directory",
//                     type: TypeEnum.Input,
//                     description:
//                       "Directory for storing any generated JSON files.",
//                   },
//                   {
//                     key: "feature_file_output_path",
//                     type: TypeEnum.Input,
//                     description: "Path to save the generated feature file.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Input,
//                   description:
//                     "Path to the generated BDD feature file or confirmation message.",
//                 },
//               },
//             },
//             className: "",
//           },
//         ],
//         edges: [],
//       },
//       welcomeText:
//         "Welcome to the BDD Test Generation Agent. This agent will generate BDD feature files based on structured test cases and patterns.",
//     },
//     category: AgentCategoryEnum.Generation,
//     logo: "/assets/images/randon-logo.png",
//   },
//   {
//     id: "4",
//     name: "BDD Test Scoring Agent",
//     description:
//       "An agent for evaluating and scoring BDD (Behavior-Driven Development) feature files based on defined quality criteria and patterns.",
//     agentFormData: {
//       agentName: "BDD Test Scoring Agent",
//       agentDescription:
//         "This agent assesses the quality of BDD feature files by comparing them to established patterns, generating a quality score to ensure test scenarios meet specified standards.",
//       prompt: `You are a QA Engineer tasked with analyzing a feature file and providing appropriate scoring for each aspect based on the given test case, feature file, and pattern file. Your analysis will cover eight key aspects of the feature file's quality and adherence to best practices.

// First, review the pattern file:
// <pattern_file>
// {pattern_file}
// </pattern_file>

// Next, review the test case:
// <test_case>
// {test_case}
// </test_case>

// Now, examine the feature file to be analyzed:
// <feature_file>
// {feature_file}
// </feature_file>

// Analyze the feature file based on the following aspects:

// 1. Overall Structure: Evaluate how well the feature file covers the required components/systems and steps involved.
// 2. Pattern File Utilization: Assess how effectively the pattern file was used to identify the right scenarios or required steps.
// 3. Input and Validation Fields: Examine the coverage of input and validation fields, considering both the pattern file and the provided test case doesn't have this information and the generated feature file should have this information.
//    The pattern file has example fields but it is not mandatory to use them as is in the feature file. so have your score value lower than 5 if the feature file has the fields as is in the pattern file.
// 4. Readability and Maintainability: Evaluate the overall readability and maintainability of the feature file. If the feature file has no comments, have your score value lower than 5.
// 5. Syntax Correctness: Assess the Syntax correctness of the feature file in terms of the steps and the expected outcome.
// 6. Given-When-Then Statements: Evaluate the use of appropriate Given, When, Then statements from the pattern file.
// 7. Overall Adherence: Assess the overall adherence to the pattern file and the test case provided.


// For each aspect, follow these steps:
// 1. Carefully analyze the feature file in relation to the specific aspect.
// 2. Provide a detailed justification for your assessment, citing specific examples from the feature file, pattern file, or test case as appropriate.
// 3. Assign a score out of 10 for the aspect, where 1 is the lowest and 10 is the highest.

// Present your analysis and scoring in a markdown format, using the following structure:

// markdown
// # Feature File Analysis

// ## 1. Overall Structure
// [Your detailed justification]
// **Score: [X]/10**

// ## 2. Pattern File Utilization
// [Your detailed justification]
// **Score: [X]/10**

// [Continue for all 8 aspects]

// ## Overall Assessment
// [Provide a brief summary of the feature file's strengths and weaknesses, and any recommendations for improvement]

// Ensure that your analysis is thorough, objective, and provides clear reasoning for each score. Use specific examples from the feature file, pattern file, and test case to support your evaluations.
//       `,
//       tools: ["Feature Evaluation Tool"],
//       model: {
//         label: "gpt-4o",
//         field: "gpt-4o",
//       },
//       flow: {
//         nodes: [
//           {
//             id: "0",
//             type: "AgentNode",
//             position: {
//               x: 350,
//               y: 150,
//             },
//             data: {
//               id: "0",
//               title: "Evaluate Feature File",
//               formData: {
//                 functions: ["evaluate_feature_file_quality"],
//                 input: [
//                   {
//                     key: "structured_test_cases",
//                     type: TypeEnum.Input,
//                     description:
//                       "Structured test cases used for evaluating the feature file.",
//                   },
//                   {
//                     key: "feature_file_result",
//                     type: TypeEnum.Input,
//                     description:
//                       "Path to the generated BDD feature file to be evaluated.",
//                   },
//                   {
//                     key: "pattern",
//                     type: TypeEnum.Input,
//                     description:
//                       "Path to the pattern file used as a reference for evaluation.",
//                   },
//                   {
//                     key: "evaluation_output_path",
//                     type: "file_path",
//                     description:
//                       "Path to save the evaluation results or quality score.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Input,
//                   description:
//                     "Quality score or evaluation result for the BDD feature file.",
//                 },
//               },
//             },
//             className: "",
//           },
//         ],
//         edges: [],
//       },
//       welcomeText:
//         "Welcome to the BDD Test Scoring Agent. This agent evaluates the quality of BDD feature files, assigning a score based on predefined patterns and standards.",
//     },
//     category: AgentCategoryEnum.Validation,
//     logo: "/assets/images/randon-logo.png",
//   },
//   {
//     id: "5",
//     name: "Database Agent",
//     description:
//       "An agent for inserting and updating structured test case data in MongoDB, facilitating organized storage and easy retrieval of test data.",
//     agentFormData: {
//       agentName: "Database Agent",
//       agentDescription:
//         "This agent handles the insertion of test case data into a MongoDB collection, ensuring that test cases are stored in a structured and queryable format for future analysis.",
//       prompt: "None",
//       tools: ["MongoDB Tool"],
//       model: {
//         label: "GPT 4",
//         field: "gpt4",
//       },
//       flow: {
//         nodes: [
//           {
//             id: "0",
//             type: "AgentNode",
//             position: {
//               x: 350,
//               y: 150,
//             },
//             data: {
//               id: "0",
//               title: "Update to MongoDB",
//               formData: {
//                 functions: ["insert_test_case_data_to_mongodb"],
//                 input: [
//                   {
//                     key: "readme_file_path",
//                     type: TypeEnum.Input,
//                     description:
//                       "Path to the README file containing test case summaries.",
//                   },
//                   {
//                     key: "db_name",
//                     type: TypeEnum.Input,
//                     description: "Name of the MongoDB database.",
//                   },
//                   {
//                     key: "collection_name",
//                     type: TypeEnum.Input,
//                     description:
//                       "Name of the MongoDB collection for storing test cases.",
//                   },
//                   {
//                     key: "connection_string",
//                     type: TypeEnum.Input,
//                     description: "Connection string for MongoDB instance.",
//                   },
//                   {
//                     key: "base_path",
//                     type: TypeEnum.Input,
//                     description:
//                       "Base URL for linked resources associated with the test cases.",
//                   },
//                 ],
//                 output: {
//                   type: "boolean",
//                   description: "Confirmation of successful MongoDB insertion.",
//                 },
//               },
//             },
//             className: "",
//           },
//         ],
//         edges: [],
//       },
//       welcomeText:
//         "Welcome to the MongoDB Agent. This agent will insert structured test case data into MongoDB for organized storage and retrieval.",
//     },
//     category: AgentCategoryEnum.Database,
//     logo: "/assets/images/randon-logo.png",
//   },
//   {
//     id: "6",
//     name: "Test Squish Bundle Agent",
//     description:
//       "An agent for preparing test cases and related files for execution with the Squish testing framework.",
//     agentFormData: {
//       agentName: "Test Squish Bundle Agent",
//       agentDescription:
//         "This agent organizes and prepares test case files and scripts for execution in the Squish automated testing framework, ensuring that all necessary files are in place for a smooth test run.",
//       prompt: "None",
//       tools: ["Squish Preparation Tool"],
//       model: {
//         label: "GPT 4",
//         field: "gpt4",
//       },
//       flow: {
//         nodes: [
//           {
//             id: "0",
//             type: "AgentNode",
//             position: {
//               x: 350,
//               y: 150,
//             },
//             data: {
//               id: "0",
//               title: "Prepare for Squish Execution",
//               formData: {
//                 functions: ["prepare_files_for_squish_execution"],
//                 input: [
//                   {
//                     key: "generated_results_path",
//                     type: TypeEnum.Input,
//                     description:
//                       "Directory path containing generated test results to be used in Squish.",
//                   },
//                   {
//                     key: "test_script_path",
//                     type: TypeEnum.Input,
//                     description:
//                       "Path to the test script file to be executed in Squish.",
//                   },
//                   {
//                     key: "output_file_name",
//                     type: TypeEnum.Input,
//                     description:
//                       "Name of the output file to be generated by Squish.",
//                   },
//                   {
//                     key: "output_folder",
//                     type: TypeEnum.Input,
//                     description:
//                       "Directory path where Squish output files will be saved.",
//                   },
//                 ],
//                 output: {
//                   type: "array",
//                   description:
//                     "Confirmation or paths of files prepared for Squish execution.",
//                 },
//               },
//             },
//             className: "",
//           },
//         ],
//         edges: [],
//       },
//       welcomeText:
//         "Welcome to the Test Squish Bundle Agent. This agent will prepare your test cases and scripts for execution in the Squish framework.",
//     },
//     category: AgentCategoryEnum.Misc,
//     logo: "/assets/images/randon-logo.png",
//   },
//   {
//     id: "1",
//     name: "Generate Test Pattern Agent",
//     description:
//       "An agent that generates structured test patterns from Excel data, parses it, and saves it for further testing processes.",
//     agentFormData: {
//       agentName: "Generate Test Pattern Agent",
//       agentDescription:
//         "This agent extracts data from an Excel file, parses it, and saves it in a structured format for creating test patterns.",
//       prompt: `You are a senior automation tester tasked with writing a feature file based on workflows derived from test cases. Instead of focusing on individual test case steps, your goal is to create a well-structured, consistent feature file by mapping predefined workflow steps to the common patterns file. Follow these steps:

// Review the Pattern File Content: <pattern_file>
// {pattern_file}
// </pattern_file>

// Analyze the Test Case Name: <test_case>
// {test_case}
// </test_case>

// From the test case name, identify the following:

// Inbound Simulator: Determine the inbound simulator (e.g., "SWF,SAA,CHIPS,FED") based on the test case name.
// Outbound Simulator: Identify the outbound simulator (e.g., "FED"). based on test case.

// Apply this simulators while generating the feature file 


// Analyze the Process Type: <process_type>
// {flow}
// </process_type>



// (compulsory step) make sure only Based on the process_type determine the workflow to be used ignore the testcase name while selecting the flow , 

// Select the Appropriate Workflow: Based on the identified simulators and process type, select one of the following predefined workflows which is similar  to {flow}:


// <Straight-through Process Workflow:>


// i) Global variables setup
// ii) Test Data Map Creation
// iii) Simulator Queue and Configuration Updates
// iv) Establish SSH connections
// v) Running inbound simulators
// vi) Running outbound simulators(compulsory step)
// vii) Control Center Application Interaction and Validation for Control Center(Payments page)
// viii)Party validation in control centre(compulsory step)
// ix) Control Center Message Log Validation
// x) Generating and Validating Message Prints


// <Repair Process Workflow - repair in control centre:>
// i) Global variables setup
// ii) Test Data Map Creation
// iii) Simulator Queue and Configuration Updates
// iv) Establish SSH connections
// v) Running inbound simulators
// vi) Launching and Validation of Data in Control Center Repair Screen(Exceptions Page)
// vii) Update credit dates or credit party and submit the transaction
// viii)Log in as a different user and verify
// ix) Run outbound simulators
// x) Application Interaction and Validation in Control Center (INQ Screen)
// xi)Control Center Message Log Validation
// xii)Generating and Validating Message Prints


// <Repair Process Workflow - repair in MTS Video screen :>
// below are steps for repair in video:-

// i) Global variables setup
// ii) Test Data Map Creation
// iii) Simulator Queue and Configuration Updates
// iv) Establish SSH connections
// v) Running inbound simulators
// vi) MTS Video Application Initialization and TRN Extraction
// vii)Test Data Update and Transaction Opening in MTS Video
// viii) Field Validation and Message Verification in 'RPR' Screen in MTS Video
// ix)Transaction Release and Application Logout from MTS Video
// x)Secondary User Validation and Outbound Process in MTS Video
// xi) Run outbound simulators
// xii) Application Interaction and Validation in Control Center (INQ Screen)
// xiii) Control Center Message Log Validation (compulsory step)
// xiv) Generating and Validating Message Prints



// Make sure while generating feature file you dont omit any workflow steps.

// Map Workflow Steps to Common Patterns: For the selected workflow, map each step directly to the corresponding common pattern in the pattern file. Use the "Usage" section of the pattern file for guidance on applying the correct "Given," "When," and "Then" steps.
// make sure for each workflow step you must have a pattern associated with it.you must not skip any of the workflow step.


// Do not map the workflow steps to test case steps.


// If a specific workflow step does not have an exact match in the pattern file, use the closest applicable pattern, while preserving the overall structure of the workflow.
// Structure Your Feature File: Structure your feature file based on the mapped workflow steps. For each mapped workflow step, use the corresponding "Given," "When," and "Then" statements from the common patterns file to ensure consistency.

// Maintain Consistency: Ensure uniformity in formatting and structure throughout the feature file. Use clear, descriptive language that is easy to understand for both technical and non-technical stakeholders.

// Handle Non-Matching Patterns: If any workflow step does not have an appropriate match in the pattern file, adapt the closest matching pattern while maintaining the overall workflow structure.

// Generate the Feature File: Write your complete feature file within <feature_file> tags, ensuring proper indentation and formatting for readability. Do not add any additional text, markdown or explanations inside the <feature_file> tags.

// Before providing your final answer, use a <scratchpad> to organize your thoughts and analyze the scenario. In your scratchpad, break down the scenario, identify key components, and make notes about each required piece of information.

// <scratchpad>

// [Your scratchpad notes go here]

// </scratchpad>

// <feature_file>

// [Your generated feature file goes here]

// </feature_file>

// Explain Your Process: After completing the feature file, briefly explain your thought process and any challenges encountered in mapping the workflow to the patterns inside <explanation> tags.

// <explanation>

// [Your explanation goes here]

// </explanation>
//       `,
//       tools: ["Excel Tool", "Parsing Tool", "File Writing Tool - Test Case"],
//       model: {
//         label: "gpt-4o",
//         field: "gpt-4o",
//       },
//       flow: {
//         nodes: [
//           {
//             id: "0",
//             type: "AgentNode",
//             position: {
//               x: 350,
//               y: 150,
//             },
//             data: {
//               id: "0",
//               title: "Extract Text from Excel",
//               formData: {
//                 functions: ["extract_text_from_excel"],
//                 input: [
//                   {
//                     key: "excel_path",
//                     type: TypeEnum.Input,
//                     description: "Path to the Excel file.",
//                     value: "test_pattern.xlsx",
//                     defaultValue: "test_pattern.xlsx",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Input,
//                   description: "Extracted sheet data",
//                 },
//               },
//             },
//             className: "",
//           },
//           {
//             id: "1",
//             type: "AgentNode",
//             position: {
//               x: 700,
//               y: 150,
//             },
//             data: {
//               id: "1",
//               title: "Parse Excel Text",
//               formData: {
//                 functions: ["parse_excel_text"],
//                 input: [
//                   {
//                     key: "sheet_data",
//                     type: TypeEnum.Input,
//                     description: "Data extracted from the Excel file.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Input,
//                   description: "Parsed test pattern data",
//                 },
//               },
//             },
//             className: "",
//           },
//           {
//             id: "2",
//             type: "AgentNode",
//             position: {
//               x: 1050,
//               y: 150,
//             },
//             data: {
//               id: "2",
//               title: "Save Test Pattern",
//               formData: {
//                 functions: ["write_test_cases_to_txt"],
//                 input: [
//                   {
//                     key: "parsed_test_pattern",
//                     type: TypeEnum.Input,
//                     description: "Parsed test pattern data.",
//                   },
//                   {
//                     key: "output_path",
//                     type: TypeEnum.Input,
//                     description: "Path to save the test pattern data.",
//                   },
//                 ],
//                 output: {
//                   type: TypeEnum.Switch,
//                   description: "Confirmation of file creation",
//                 },
//               },
//             },
//             className: "",
//           },
//         ],
//         edges: [
//           {
//             id: "e0-1",
//             source: "0",
//             target: "1",
//             type: "smoothstep",
//           },
//           {
//             id: "e1-2",
//             source: "1",
//             target: "2",
//             type: "smoothstep",
//           },
//         ],
//       },
//       welcomeText:
//         "Welcome to the Generate Test Pattern Agent. This agent extracts, parses, and saves test patterns for further use.",
//     },
//     category: AgentCategoryEnum.Generation,
//     logo: "/assets/images/randon-logo.png",
//   },

  {
    id: "1",
    name: "EJB Bean Analyzer",
    description:
      "Analyzes an EJB bean class to extract details such as class name, properties, constructors, and methods.",
    agentFormData: {
      agentName: "EJB Bean Analyzer",
      agentDescription:
        "This agent analyzes EJB bean classes to extract and provide a comprehensive markdown output of the class structure and its components.",
      prompt:`You are tasked with analyzing a given Java bean class and producing a comprehensive markdown output. Follow these instructions carefully:
1. You will be provided with a Java bean class in the following format:

<java_bean_class>
{{bean}}
</java_bean_class>

2. Analyze the provided Java bean class thoroughly. Pay attention to:
   - Class name and any annotations
   - Fields/properties and their types
   - Getter and setter methods
   - Any additional methods
   - Constructors
   - Implemented interfaces or extended classes

3. Produce a comprehensive markdown output that includes the following sections:

   a. Class Overview
      - Provide a brief description of the class and its purpose
      - Mention any interfaces implemented or classes extended

   b. Properties
      - List all properties/fields
      - For each property, include:
        - Name
        - Type
        - Access modifier
        - Any annotations

   c. Constructors
      - List all constructors
      - For each constructor, include:
        - Parameters (if any)
        - Brief description of its purpose

   d. Methods
      - List all methods, including getters and setters
      - For each method, include:
        - Name
        - Return type
        - Parameters (if any)
        - Brief description of its purpose

   e. Additional Notes
      - Mention any notable patterns or design choices
      - Discuss any potential improvements or best practices that could be applied

4. Format your markdown output as follows:
   - Use appropriate markdown syntax for headers, lists, and code blocks
   - Use backticks () for inline code references
   - Use triple backticks () for multi-line code blocks
   - Use bold (**) for emphasis where appropriate

5. Begin your response with <markdown> and end it with </markdown>. Do not include these tags in the actual markdown content.

6. Ensure your analysis is thorough, clear, and well-organized. Provide insights that would be helpful for someone trying to understand and potentially use or modify this Java bean class.`,
      tools: ["Bean Analysis Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Analyze EJB Bean",
              formData: {
                functions: ["analyze_bean"],
                input: [
                  {
                    key: "bean_input_filepath",
                    type: "file",
                    description: "Path to the EJB bean file.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Bean analysis result in markdown format.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the EJB Bean Analyzer. Provide an EJB bean class file to start analyzing.",
    },
    category: AgentCategoryEnum.Analyser,
    logo: "/assets/images/eji-bean-logo.png",
  },
  {
    id: "2",
    name: "Proto File Generator",
    description:
      "Generates a .proto file from the provided EJB bean and models for gRPC services.",
    agentFormData: {
      agentName: "Proto File Generator",
      agentDescription:
        "This agent generates a .proto file based on EJB bean methods and additional model definitions.",
      prompt:
        `You are a Senior Java Developer tasked with generating a .proto file for the conversion of EJB Services to gRPC services.
    Your objective is to create a .proto file that mirrors the functionality of the existing EJB Services by defining the gRPC service and messages.

To achieve this, follow the steps below:
- Analyze the EJB bean class to identify the methods that need to be converted to gRPC service methods.
- Define the service and message structures in the .proto file based on the EJB methods.
- The .proto file should include the following:
    - The service definition
    - The message definitions
- The .proto file should be structured in a way that it can be used to generate the necessary Java code for the gRPC service.
- The .proto file should be complete and should not contain any placeholders like 
    a. // Define the fields
    b. // Define more RPCs based on other methods in ScanlineBean
    c. // Add other fields from [message]
    d. // Add other types as needed
    e. // ...
- Use the method definitions from the EJB class to create the appropriate service and message structures in the .proto file.
- The .proto file should be generated based on the provided EJB bean class and should include all services and messages.
- Use the EJB bean class to define the corresponding service and message structures in the .proto file.
- Additionally use the models provided to define the message structures in the .proto file.

- The EJB bean class is provided below:
 {bean}  
- Additional information:
 {models}

Output:
- Generate the complete .proto file from the provided EJB bean class and models. 
- Don't leave any placeholder in the proto file like  
    a. // Define the fields
    b. // Define more RPCs based on other methods in ScanlineBean
    c. // Add other fields from [message]
    d. // Add other types as needed
    e. // ...`,
      tools: ["Proto File Generator Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Analyze Bean & Models",
              formData: {
                functions: ["generate_proto_file"],
                input: [
                  {
                    key: "bean_input_filepath",
                    type: "file",
                    description: "Path to the EJB bean file.",
                  },
                  {
                    key: "models",
                    type: "list",
                    description: "List of model file paths.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Generated .proto file.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the Proto File Generator. Provide an EJB bean and model files to generate a .proto file.",
    },
    category: AgentCategoryEnum.Generation,
    logo: "/assets/images/proto-generator-logo.png",
  },
  {
    id: "3",
    name: "gRPC Service Generator",
    description:
      "Generates a complete Java implementation for a gRPC service based on an EJB bean and a .proto file.",
    agentFormData: {
      agentName: "gRPC Service Implementation Generator",
      agentDescription:
        "This agent generates the Java implementation for gRPC services, preserving the functionality of EJB bean methods.",
      prompt:
        ` You are a Senior Java Developer tasked with generating a gRPC service implementation based on the provided EJB bean class and the .proto file.
    Your objective is to copy over the implementation from the EJB service methods as is and just make the bean methods to grpc service methods and not mock any implementation.    

To achieve this, follow the steps below:
- Analyze the EJB bean class and the .proto file to understand the service methods and message structures.
- Generate the gRPC service implementation in Java based on the EJB bean class and the .proto file.
- The gRPC service should include the necessary methods to handle the requests defined in the .proto file.
- The gRPC service should be structured in a way that it can be used to handle the requests from the gRPC client.
- The gRPC service should be implemented in a way that preserves the functionality of the EJB service methods.
- Don't mock the implementation for the service methods, copy over the implementation as is and just make the bean to grpc service .
- Implement the corresponding gRPC Service methods:
    a. Translate the EJB service methods into gRPC service methods, ensuring all functionalities are preserved
    b. Generate gRPC Service code for all the methods defined in the EJB bean class and the .proto file.
    c. gRPC service method implementation should copy over the existing functionality from the EJB service methods as is.
- The gRPC service should be able to handle the requests defined in the .proto file and provide the necessary responses.
- The gRPC service should be complete and should not contain any placeholders like
    a. // Implement other service methods similarly....
    b. // Implement the helper methods
    c. // Implement the service methods
    d. // Implement other methods similarly...
    e. // ...
- The gRPC service should be generated based on the provided EJB bean class and the .proto file.

- The EJB bean class is provided below:
 {bean}  
- Proto file is provided below:
 {proto}

Output:
- Generate the complete Java implementation of the gRPC service based on the provided EJB bean class and the .proto file.
- Output should only include complete and functional Java file without any placeholders like 
    a. // Implement other service methods similarly....
    b. // Implement the helper methods
    c. // Implement the service methods
    d. // Implement other methods similarly...
    e. // ...


NOTE: For each method in gRPC service, copy over the implementation from the EJB service methods as is and just make 
the bean methods to grpc service methods don't mock the implementation.`,
      tools: ["gRPC Service Generator Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Generate gRPC Service Implementation",
              formData: {
                functions: ["generate_grpc_service"],
                input: [
                  {
                    key: "bean_input_filepath",
                    type: "file",
                    description: "Path to the EJB bean file.",
                  },
                  {
                    key: "proto_result",
                    type: "result",
                    description: "Result from the .proto file generation.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Java implementation of the gRPC service.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the gRPC Service Implementation Generator. Provide the necessary files to generate a complete Java service implementation.",
    },
    category: AgentCategoryEnum.Generation,
    logo: "/assets/images/grpc-service-logo.png",
  },
  {
    id: "4",
    name: "gRPC ServerClient Generator",
    description:
      "Generates Java code for both gRPC server and client based on the .proto file and service implementation.",
    agentFormData: {
      agentName: "gRPC Server and Client Generator",
      agentDescription:
        "This agent creates Java implementations for both gRPC server and client, enabling seamless communication as defined in the .proto file.",
      prompt:
        `You are a Senior Java Developer tasked with creating a gRPC server and client based on the 
    provided .proto file and the gRPC service implementation.
    Your objective is to generate the Java code for the gRPC server and client that can communicate with each other 
    based on the defined service and message structures in the .proto file.

To achieve this, follow the steps below:
- Implement the gRPC server based on the provided .proto file and the gRPC service implementation.
- The gRPC server should be able to handle the requests defined in the .proto file and invoke the corresponding methods in the gRPC service implementation.
- Implement the gRPC client based on the provided .proto file.
- The gRPC client should be able to send requests to the gRPC server and receive responses.
- The gRPC client should be able to handle the responses received from the gRPC server.
- The gRPC server and client should be implemented in separate Java files.
- The gRPC server should be able to start and listen for incoming requests.
- The gRPC client should be able to connect to the gRPC server and send requests.
- The gRPC client should be able to handle the responses received from the gRPC server.
- The gRPC server and client should be able to communicate with each other based on the defined service and message structures in the .proto file.
- The gRPC client should implement the necessary logic to send requests to the gRPC server and handle the responses for all the methods defined in the .proto file.
- The Java code should be generated based on the provided .proto file and the gRPC service implementation.
- Please ensure that the generated Java code is complete and does not contain any placeholders like
    a. Implement the server logic
    b. Implement the client logic
    c. // Implement the server methods
    d. // Implement the client methods
    e. // ...
- The .proto file and the gRPC service implementation are provided below:
 {proto}
 {service}

Output:
- Generate the complete java code involved in the implementation of the gRPC Server and Client.
- Output should only include java file.`,
      tools: ["gRPC ServerClient Generator Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Generate gRPC Server & Client",
              formData: {
                functions: ["generate_grpc_server_client"],
                input: [
                  {
                    key: "proto_result",
                    type: "result",
                    description: "Result from the .proto file generation.",
                  },
                  {
                    key: "service_java_result",
                    type: "result",
                    description: "Java implementation of the gRPC service.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Generated gRPC server and client Java code.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the gRPC Server and Client Generator. Provide the necessary inputs to generate server and client code.",
      category: "Generator",
      logo: "/assets/images/grpc-server-client-logo.png",
    },
    category: AgentCategoryEnum.Generation,
    logo: "/assets/images/grpc-server-client-logo.png",
  },
  {
    id: "5",
    name: "Generated Code Reviewer",
    description:
      "Thoroughly reviews generated gRPC-based implementation, including proto, service, server, and client code.",
    agentFormData: {
      agentName: "Generated Code Reviewer",
      agentDescription:
        "This agent reviews the generated code for gRPC implementations, assessing correctness, efficiency, and adherence to best practices.",
      prompt:
        `You are a Senior Software Developer tasked with reviewing the gRPC-based implementation derived from an existing EJB class. You will be provided with four code snippets: the proto file, ServiceImpl, gRPC Server, and gRPC Client. Your job is to review each of these components thoroughly and provide a comprehensive review in markdown format.

      Here are the detailed instructions for your review:

      1. First, review the proto file:
      <proto_review>
      {proto_code}
      </proto_review>

      Analyze the proto file for:
      - Proper message and service definitions
      - Appropriate use of data types
      - Clarity and completeness of the API design

      2. Next, review the ServiceImpl code:
      <service_impl_review>
      {service_impl_code}
      </service_impl_review>

      Examine the ServiceImpl for:
      - Correct implementation of the service defined in the proto file
      - Proper error handling
      - Efficient use of resources
      - Adherence to best practices and coding standards

      3. Then, review the gRPC Server code:
      <grpc_server_review>
      {grpc_server_code}
      </grpc_server_review>

      Assess the gRPC Server for:
      - Correct setup and configuration
      - Proper integration with the ServiceImpl
      - Appropriate error handling and logging
      - Scalability considerations

      4. Finally, review the gRPC Client code:
      <grpc_client_review>
      {grpc_client_code}
      </grpc_client_review>

      Evaluate the gRPC Client for:
      - Correct usage of the generated client stubs
      - Proper error handling and retry logic
      - Efficient management of connections
      - Clear and maintainable code structure

      After reviewing each component, compile your findings into a comprehensive review using the following markdown format:

      markdown
      # gRPC Implementation Review

      ## 1. Proto File Review
      [Your detailed review of the proto file]

      ## 2. ServiceImpl Review
      [Your detailed review of the ServiceImpl]

      ## 3. gRPC Server Review
      [Your detailed review of the gRPC Server]

      ## 4. gRPC Client Review
      [Your detailed review of the gRPC Client]

      ## 5. Overall Assessment
      [Provide an overall assessment of the implementation, highlighting strengths and areas for improvement]

      ## 6. Recommendations
      [List specific recommendations for improving the implementation]
      

      In your review:
      - Be thorough and specific in your analysis
      - Provide concrete examples from the code to support your points
      - Suggest improvements where applicable
      - Consider both the functionality and the maintainability of the code
      - Address any potential performance or scalability issues

      Your final output should be a well-structured, comprehensive review that provides valuable insights and actionable recommendations for improving the gRPC implementation.`,
      tools: ["Generated Code Reviewer Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Review Generated Code",
              formData: {
                functions: ["review_generated_code"],
                input: [
                  {
                    key: "server_client_java_result",
                    type: "result",
                    description: "Generated gRPC server and client Java code.",
                  },
                  {
                    key: "proto_result",
                    type: "result",
                    description: "Result from the .proto file generation.",
                  },
                  {
                    key: "service_java_result",
                    type: "result",
                    description: "Java implementation of the gRPC service.",
                  },
                ],
                output: {
                  type: "file",
                  description:
                    "Review of the generated code in markdown format.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the Generated Code Reviewer. Provide the code outputs to initiate the review process.",
    },
    category: AgentCategoryEnum.Validation,
    logo: "/assets/images/code-reviewer-logo.png",
  },
  {
    id: "6",
    name: "Generated Code Scorer",
    description:
      "Evaluates and scores the quality of the generated gRPC-based code for proto, service, server, and client.",
    agentFormData: {
      agentName: "Generated Code Scorer",
      agentDescription:
        "This agent scores the quality of generated gRPC implementations based on completeness, correctness, efficiency, and adherence to best practices.",
      prompt:
        `You are a Senior Software Developer tasked with scoring the gRPC-based implementation derived from an existing EJB class. You will be provided with four code sections: proto, ServiceImpl, gRPC Server, and gRPC Client. Your job is to analyze each section and provide a comprehensive scoring in markdown format.

        Here are the code sections you will be analyzing:

        1. Proto file:
        <proto>
        {proto_code}
        </proto>

        2. ServiceImpl:
        <service_impl>
        {service_impl_code}
        </service_impl>

        3. gRPC Server:
        <grpc_server>
        {grpc_server_code}
        </grpc_server>

        4. gRPC Client:
        <grpc_client>
        {grpc_client_code}
        </grpc_client>

        Scoring Criteria:
        For each code section, consider the following aspects:
        1. Correctness: Is the code syntactically correct and does it follow gRPC best practices?
        2. Completeness: Does the code cover all necessary functionality?
        3. Efficiency: Is the code optimized and efficient?
        4. Readability: Is the code well-organized and easy to understand?
        5. Error Handling: Does the code properly handle potential errors?

        Instructions for analysis:
        1. Carefully read through each code section.
        2. For each section, consider the scoring criteria mentioned above.
        3. Make notes on the strengths and weaknesses of each section.
        4. Assign a score out of 10 for each criterion in each section.
        5. Provide brief explanations for your scoring decisions.

        After analyzing all sections, compile your findings into a comprehensive scoring report in markdown format. Your report should include:

        1. An overall summary of the implementation
        2. Individual scores and explanations for each code section
        3. A final overall score for the entire implementation

        Please provide your comprehensive scoring report within <scoring_report> tags, using markdown formatting. Ensure that your report is well-structured, easy to read, and provides clear justifications for each score given.
`,
      tools: ["Generated Code Scorer Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Score Generated Code",
              formData: {
                functions: ["score_generated_code"],
                input: [
                  {
                    key: "server_client_java_result",
                    type: "result",
                    description: "Generated gRPC server and client Java code.",
                  },
                  {
                    key: "proto_result",
                    type: "result",
                    description: "Result from the .proto file generation.",
                  },
                  {
                    key: "service_java_result",
                    type: "result",
                    description: "Java implementation of the gRPC service.",
                  },
                ],
                output: {
                  type: "file",
                  description:
                    "Score and evaluation report in markdown format.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the Generated Code Scorer. Provide the outputs to calculate a quality score for the implementation.",
    },
    category: AgentCategoryEnum.Validation,
    logo: "/assets/images/code-scorer-logo.png",
  },

  {
    id: "7",
    name: "DAL Code Analyzer",
    description:
      "Analyzes Data Access Layer Java code written for Oracle database using JDBC.",
    agentFormData: {
      agentName: "DAL Code Analyzer",
      agentDescription:
        "This agent extracts details such as methods, input parameters, and stored procedures from the provided Data Access Layer Java code.",
      prompt:
        `
        You are tasked with analyzing Java code to extract information about methods, stored procedures, and functions. Follow these steps carefully:

        1. You will be provided with Java code inside <java_code> tags. Analyze this code thoroughly.

        <java_code>
            {java_code}
        </java_code>

        2. Examine the code and identify all methods within the Java classes. Pay attention to both instance methods and static methods.
        3. For each method you identify, extract the following information:
          - Method name
          - Input parameters (including their types)
          - Return type (output)
          - Access modifier (public, private, protected, or default)

        4. Look for any stored procedures or functions within the code. These might be indicated by specific annotations or comments.
        5. Present your findings in a structured format using the following XML tags:
          <methods>
            <method>
              <name>methodName</name>
              <access_modifier>accessModifier</access_modifier>
              <input_parameters>
                <parameter>
                  <type>parameterType</type>
                  <name>parameterName</name>
                </parameter>
                <!-- Repeat for each parameter -->
              </input_parameters>
              <return_type>returnType</return_type>
            </method>
            <!-- Repeat for each method -->
          </methods>

          <stored_procedures_and_functions>
            <item>
              <name>itemName</name>
              <type>storedProcedure/function</type>
              <description>briefDescription</description>
            </item>
            <!-- Repeat for each stored procedure or function -->
          </stored_procedures_and_functions>

        If no methods, stored procedures, or functions are found, include an empty tag for that section.

        6. After the structured output, provide a brief summary of your findings, including the total number of methods, stored procedures, and functions identified.

        Begin your analysis now and present your findings as instructed.
      `,
      tools: ["Analyze DAL Java Code Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Analyze DAL Java Code",
              formData: {
                functions: ["analyze_dal_java_code"],
                input: [
                  {
                    key: "java_code_path",
                    type: "file",
                    description: "Path to the Java code file.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Analysis result in XML format.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the DAL Code Analyzer. Provide the Java code file for analysis.",
    },
    category: AgentCategoryEnum.Analyser,
    logo: "/assets/images/dal-analyzer-logo.png",
  },
  {
    id: "8",
    name: "Oracle Package Analyzer",
    description:
      "Analyzes Oracle package scripts to extract details of stored procedures and functions.",
    agentFormData: {
      agentName: "Oracle Package Analyzer",
      agentDescription:
        "This agent identifies and reports on stored procedures and functions from an Oracle package.",
      prompt:`You are tasked with analyzing an Oracle package to extract information about the stored procedures and functions it contains. The package content will be provided to you, and you need to carefully examine it to identify and report on its components.

      Here is the Oracle package to analyze:
  
      <oracle_package>
      {oracle_package}
      </oracle_package>
  
      Your task is to:
      1. Identify all stored procedures and functions within the package.
      2. For each procedure or function, extract the following information:
        a. Name
        b. Type (procedure or function)
        c. Parameters (name and data type)
        d. Return type (for functions)
        e. A brief description of its purpose (inferred from the code or comments)
  
      Follow these steps to analyze the package:
      1. Carefully read through the entire package.
      2. Look for procedure and function declarations, typically starting with "PROCEDURE" or "FUNCTION" keywords.
      3. For each procedure or function, extract the required information.
      4. Infer the purpose of each procedure or function based on its name, parameters, and any available comments or code logic.
  
      Present your findings in the following format:
  
      <analysis>
        <component>
          <name>[Name of procedure or function]</name>
          <type>[Procedure or Function]</type>
          <parameters>
            <param>
              <name>[Parameter name]</name>
              <data_type>[Parameter data type]</data_type>
            </param>
            [Repeat for each parameter]
          </parameters>
          <return_type>[Return type for functions, omit for procedures]</return_type>
          <description>[Brief description of the component's purpose]</description>
        </component>
        [Repeat for each procedure or function]
      </analysis>
  
      Here's an example of a good response:
  
      <analysis>
        <component>
          <name>GET_EMPLOYEE_DETAILS</name>
          <type>Function</type>
          <parameters>
            <param>
              <name>p_employee_id</name>
              <data_type>NUMBER</data_type>
            </param>
          </parameters>
          <return_type>SYS_REFCURSOR</return_type>
          <description>Retrieves employee details for a given employee ID</description>
        </component>
        <component>
          <name>UPDATE_SALARY</name>
          <type>Procedure</type>
          <parameters>
            <param>
              <name>p_employee_id</name>
              <data_type>NUMBER</data_type>
            </param>
            <param>
              <name>p_new_salary</name>
              <data_type>NUMBER</data_type>
            </param>
          </parameters>
          <description>Updates the salary of an employee</description>
        </component>
      </analysis>
  
      And here's an example of a bad response to avoid:
  
      <analysis>
      The package contains some procedures and functions related to employee management.
      </analysis>
  
      Remember to use the specified XML tags to structure your response and provide detailed information for each component you identify in the package.
      Be thorough in your analysis and make sure to capture all the required information for each procedure and function.
      `,
      tools: ["Analyze Oracle Package Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Analyze Oracle Package",
              formData: {
                functions: ["analyze_oracle_package"],
                input: [
                  {
                    key: "oracle_package_path",
                    type: "file",
                    description: "Path to the Oracle package script file.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Analysis result in XML format.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the Oracle Package Analyzer. Provide the package script to analyze its procedures and functions.",
    },
    category: AgentCategoryEnum.Analyser,
    logo: "/assets/images/oracle-package-logo.png",
  },

  {
    id: "9",
    name: "MongoDB Schema Generator",
    description:
      "Creates a MongoDB schema based on Oracle package scripts and SQL DDL statements.",
    agentFormData: {
      agentName: "MongoDB Schema Generator",
      agentDescription:
        "This agent designs MongoDB schemas using SQL DDL scripts and Oracle package information.",
      prompt:
        `You are tasked with creating a possible MongoDB schema based on SQL Table creation DDL statements and a function to access the data. Your goal is to design an efficient MongoDB schema that leverages embedding where appropriate.

    First, review the following SQL DDL statements and data access function:

    <DDL_statements>
    {ddl_scripts}
    </DDL_statements>

    <data_access_function>
    {oracle_package}
    </data_access_function>

    To complete this task, follow these steps:

    1. Analyze the DDL statements:
      - Identify the tables and their relationships
      - Note the primary keys, foreign keys, and other constraints
      - Pay attention to the data types of each field

    2. Consider embedding opportunities:
      - Look for one-to-many or one-to-few relationships that could benefit from embedding
      - Identify which collections could be embedded within others to reduce the need for separate collections

    3. Design the MongoDB schema:
      - Start with the main entities as top-level collections
      - Embed related data where appropriate, based on your analysis
      - Ensure that the schema allows for efficient querying based on the provided data access function

    4. Document your schema:
      - Use JSON-like notation to represent your MongoDB schema
      - Include comments to explain your design decisions, especially regarding embedding

    Present your final MongoDB schema inside <mongodb_schema> tags. Use the following format for each collection:

    <mongodb_schema>
    {{
      "collection_name": {{
        "field1": "type",
        "field2": "type",
        "embedded_document": {{
          "subfield1": "type",
          "subfield2": "type"
        }},
        "embedded_array": [
          {{
            "array_item_field1": "type",
            "array_item_field2": "type"
          }}
        ]
      }}
    }}
    // Add comments here to explain your design decisions
    </mongodb_schema>

    Remember to leverage embedding where it makes sense, but also consider the trade-offs between embedding and using separate collections. 
    Your goal is to create an efficient schema that supports the querying needs implied by the data access function while taking advantage of MongoDB's document-oriented structure.
    `,
      tools: ["Create MongoDB Schema Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Generate MongoDB Schema",
              formData: {
                functions: ["generate_mongodb_schema"],
                input: [
                  {
                    key: "oracle_package_path",
                    type: "file",
                    description: "Path to the Oracle package file.",
                  },
                  {
                    key: "ddl_scripts_path",
                    type: "file",
                    description: "Path to the DDL scripts file.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Generated MongoDB schema.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the MongoDB Schema Generator. Provide Oracle and SQL DDL inputs to generate a MongoDB schema.",
    },
    category: AgentCategoryEnum.Generation,
    logo: "/assets/images/mongodb-schema-logo.png",
  },

  {
    id: "10",
    name: "MongoDB DAL Code Generator",
    description:
      "Generates the MongoDB Data Access Layer code in Spring Data using the MongoDB schema.",
    agentFormData: {
      agentName: "MongoDB DAL Generator",
      agentDescription:
        "This agent generates Java code for the Data Access Layer, including model classes and repository interfaces, based on the MongoDB schema.",
      prompt:
        `You are tasked with refactoring Java code to fetch data from MongoDB and leverage the MongoDB schema to create model classes and repository interfaces. Follow these instructions carefully to complete the task:

    1. First, you will be provided with the MongoDB schema. Analyze it carefully to understand the structure of the data.

    <mongodb_schema>
    {mongodb_schema}
    </mongodb_schema>

    2. Next, you will be presented with the existing Java code that needs to be refactored. Review it to understand its current functionality.

    <java_code>
    {java_code}
    </java_code>

    3. Now, follow these steps to refactor the code:

      a. Create model classes:
          - For each collection in the MongoDB schema, create a corresponding Java model class.
          - Use appropriate annotations (e.g., @Document, @Id) to map the class to the MongoDB collection.
          - Include all fields from the schema as private attributes in the class.
          - Generate getter and setter methods for each attribute.

      b. Create repository interfaces:
          - For each model class, create a corresponding repository interface.
          - Extend the MongoRepository interface, specifying the model class and the type of its ID field.
          - Add any custom query methods if needed, based on the existing Java code's requirements.

      c. Modify the existing Java code:
          - Replace any JDBC or SQL-related code with MongoDB operations.
          - Inject the appropriate repository interfaces into the classes that need database access.
          - Update method implementations to use the repository methods for CRUD operations.
          - If there are any complex queries, use MongoDB's query methods or the @Query annotation in the repository interfaces.

    4. After refactoring, provide the following output:

      a. The refactored Java code, including:
          - Model classes
          - Repository interfaces
          - Modified existing classes

      b. A brief explanation of the changes made and how the new code interacts with MongoDB.

    Present your refactored code and explanation inside <refactored_code> tags. Ensure that your code follows Java best practices and is well-commented.`,
      tools: ["Generate MongoDB DAL Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Generate MongoDB DAL Code",
              formData: {
                functions: ["generate_dal_code"],
                input: [
                  {
                    key: "mongodb_schema_result",
                    type: "result",
                    description: "Result from the MongoDB schema generation.",
                  },
                  {
                    key: "oracle_package_path",
                    type: "file",
                    description: "Path to the Oracle package file.",
                  },
                  {
                    key: "java_code_path",
                    type: "file",
                    description: "Path to the existing Java code.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Generated MongoDB Data Access Layer Java code.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the MongoDB DAL Code Generator. Provide the necessary inputs to generate Data Access Layer code.",
      category: "Generator",
      logo: "/assets/images/mongodb-dal-logo.png",
    },
    category: AgentCategoryEnum.Generation,
    logo: "/assets/images/mongodb-dal-logo.png",
  },

  {
    id: "11",
    name: "DAL and MongoDB Schema Reviewer",
    description:
      "Reviews the generated Data Access Layer code and MongoDB schema for completeness and correctness.",
    agentFormData: {
      agentName: "DAL and MongoDB Schema Reviewer",
      agentDescription:
        "This agent reviews the refactored Java DAL code and MongoDB schema to ensure the preservation of original functionality and adherence to best practices.",
      prompt:
        `You are tasked with reviewing refactored Java code that fetches data from MongoDB and creates model classes and repository interfaces. This code replaces an earlier version that used JDBC to fetch data from Oracle using stored procedures. Your goal is to ensure that the refactored code covers all the original functionality.

    You will be provided with four pieces of information:
    
    1. The new MongoDB schema:
    <new_mongodb_schema>
    {mongodb_schema}
    </new_mongodb_schema>
    
    2. The old Java code that used JDBC and Oracle:
    <old_java_code>
    {legacy_java_code}
    </old_java_code>
    
    3. The old Oracle package containing stored procedures:
    <old_oracle_package>
    {oracle_package}
    </old_oracle_package>
    
    4. The new Java code that uses MongoDB:
    <new_java_code>
    {generated_java_code}
    </new_java_code>
    
    To complete this task, follow these steps:
    
    1. Review the new MongoDB schema to understand the data structure.
    2. Analyze the old Java code and Oracle package to identify all functionalities and data operations.
    3. Examine the new Java code, focusing on model classes and repository interfaces.
    4. Compare the functionality of the old and new code, ensuring that all operations from the old version are covered in the new version.
    
    In your analysis, pay special attention to:
    - Data retrieval operations
    - Data manipulation operations
    - Error handling
    - Transaction management
    - Any business logic implemented in the stored procedures
    
    After your analysis, provide your findings in the following format:
    
    <review>
    <functionality_coverage>
    [Provide an overall assessment of whether the new code covers all the original functionality. Use percentages if possible.]
    </functionality_coverage>
    
    <missing_functionality>
    [List any functionalities from the old code that are not present in the new code. If none, state "None found."]
    </missing_functionality>
    
    <additional_functionality>
    [List any new functionalities in the refactored code that were not present in the original. If none, state "None found."]
    </additional_functionality>
    
    <potential_issues>
    [Highlight any potential issues or areas of concern in the refactored code.]
    </potential_issues>
    
    <recommendations>
    [Provide recommendations for improving the refactored code or addressing any missing functionality.]
    </recommendations>
    </review>
    
    Ensure your review is thorough and considers all aspects of the code, including data integrity, performance, and maintainability. If you need to make any assumptions due to lack of information, clearly state them in your review.
`,
      tools: ["Review Generated DAL Code"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Review DAL and Schema",
              formData: {
                functions: ["review_dal_schema"],
                input: [
                  {
                    key: "oracle_package_path",
                    type: "file",
                    description: "Path to the Oracle package file.",
                  },
                  {
                    key: "java_code_path",
                    type: "file",
                    description: "Path to the existing Java code.",
                  },
                  {
                    key: "mongodb_schema_result",
                    type: "result",
                    description: "Result from the MongoDB schema generation.",
                  },
                  {
                    key: "mongo_dataaccess_result",
                    type: "result",
                    description: "Generated Data Access Layer Java code.",
                  },
                ],
                output: {
                  type: "file",
                  description: "Review report in markdown format.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the DAL and MongoDB Schema Reviewer. Provide the outputs to initiate the review process.",
    },
    category: AgentCategoryEnum.Validation,
    logo: "/assets/images/dal-reviewer-logo.png",
  },
  {
    id: "12",
    name: "DAL and MongoDB Schema Scorer",
    description:
      "Scores the quality of the generated DAL code and MongoDB schema based on completeness, correctness, and efficiency.",
    agentFormData: {
      agentName: "DAL and MongoDB Schema Scorer",
      agentDescription:
        "This agent scores the refactored Java Data Access Layer and MongoDB schema for quality, functionality coverage, and adherence to best practices.",
      prompt:
        `You are tasked with evaluating the refactoring of Java code that previously fetched data from Oracle using JDBC and stored procedures, to now fetch data from MongoDB and create model classes and repository interfaces. Your goal is to assess whether the refactored code covers all the original functionality and provide a score based on the completeness and correctness of the refactoring.

You will be provided with four pieces of information:

1. Old Java Code:
<old_java_code>
{legacy_java_code}
</old_java_code>

2. Old Oracle Package:
<old_oracle_package>
{oracle_package}
</old_oracle_package>

3. New MongoDB Schema:
<new_mongodb_schema>
{mongodb_schema}
</new_mongodb_schema>

4. New Java Code:
<new_java_code>
{generated_java_code}
</new_java_code>

Please follow these steps to evaluate the refactoring:

1. Analyze the old Java code and Oracle package to understand the original functionality, data structures, and operations performed.

2. Examine the new MongoDB schema to ensure it captures all necessary data fields and relationships from the original Oracle database.

3. Review the new Java code, focusing on:
   a. Model classes that represent the data structures
   b. Repository interfaces for database operations
   c. Implementation of data fetching from MongoDB
   d. Any additional utility classes or helper methods

4. Compare the functionality of the old and new code, considering:
   a. All data fields are accounted for
   b. All database operations (CRUD) are implemented
   c. Business logic and data transformations are preserved
   d. Error handling and edge cases are addressed

5. Evaluate the refactoring based on the following criteria:
   a. Completeness: All original functionality is preserved
   b. Correctness: The new implementation accurately reflects the old one
   c. Efficiency: The new code makes appropriate use of MongoDB features
   d. Code quality: The new code follows Java and MongoDB best practices

6. Provide your reasoning for the evaluation, highlighting strengths and any areas for improvement.

7. Assign a score from 0 to 100, where:
   0-20: Poor refactoring, major functionality missing or incorrect
   21-40: Inadequate refactoring, significant gaps in functionality or correctness
   41-60: Partial refactoring, some key functionality missing or incorrectly implemented
   61-80: Good refactoring, most functionality preserved with minor issues
   81-100: Excellent refactoring, all functionality preserved and well-implemented

Please provide your evaluation in the following format:

<evaluation>
<reasoning>
[Your detailed reasoning here, addressing each of the criteria mentioned above]
</reasoning>

<score>[Your numerical score between 0 and 100]</score>
</evaluation>`,
      tools: ["Score Generated DAL Tool"],
      model: {
        label: "gpt-4o",
        field: "gpt-4o",
      },
      flow: {
        nodes: [
          {
            id: "0",
            type: "AgentNode",
            position: {
              x: 350,
              y: 150,
            },
            data: {
              id: "0",
              title: "Score DAL and Schema",
              formData: {
                functions: ["score_dal_schema"],
                input: [
                  {
                    key: "oracle_package_path",
                    type: "file",
                    description: "Path to the Oracle package file.",
                  },
                  {
                    key: "java_code_path",
                    type: "file",
                    description: "Path to the existing Java code.",
                  },
                  {
                    key: "mongodb_schema_result",
                    type: "result",
                    description: "Result from the MongoDB schema generation.",
                  },
                  {
                    key: "mongo_dataaccess_result",
                    type: "result",
                    description: "Generated Data Access Layer Java code.",
                  },
                ],
                output: {
                  type: "file",
                  description:
                    "Score and evaluation report in markdown format.",
                },
              },
            },
            className: "",
          },
        ],
        edges: [],
      },
      welcomeText:
        "Welcome to the DAL and MongoDB Schema Scorer. Provide the outputs to calculate the score for the implementation.",
    },
    category: AgentCategoryEnum.Validation,
    logo: "/assets/images/dal-scorer-logo.png",
  },
];
